<template>
  <div class="form-floating mb-3">
    <input
        @input="handleInput"
        :type="type"
        class="form-control"
        :id="property"
        :value="value"
        :class="{'is-invalid': error }"
        :disabled="disabled"
    >
    <label :for="property">{{ name }}<span class="text-danger" v-if="isRequired">*</span></label>
    <message-error :code="errorCode" :hasError="error"/>
  </div>
</template>

<script>
import MessageError from '@/core/components/MessageError.vue'

export default {
  name: 'TextField',
  components: { MessageError },
  props: {
    value:{}, 
    property:{ type: String }, 
    name:{ type: String }, 
    type:{ type: String, default: 'text' }, 
    error:{ type: Boolean }, 
    disabled:{ type: Boolean, default: false}, 
    isRequired:{ type: Boolean },
    errorCode: { type: String }
  }
  ,
  methods: {
    handleInput (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style scoped>
input{
  border-radius: 0 !important;
}
</style>
